// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * Base definition for all elements that are defined inside a resource - but not those in a data type.
 */
export type IBackboneElement = fhir.IFhirElement & {
  /**
   * There can be no stigma associated with the use of extensions by any application, project, or standard - regardless of the institution or jurisdiction that uses or defines the extensions.  The use of extensions is what allows the FHIR specification to retain a core level of simplicity for everyone.
   */
  modifierExtension?: fhir.IExtension[]|undefined;
}
/**
 * Base definition for all elements that are defined inside a resource - but not those in a data type.
 */
export class BackboneElement extends fhir.FhirElement implements fhir.IBackboneElement {
  /**
   * There can be no stigma associated with the use of extensions by any application, project, or standard - regardless of the institution or jurisdiction that uses or defines the extensions.  The use of extensions is what allows the FHIR specification to retain a core level of simplicity for everyone.
   */
  public modifierExtension?: fhir.Extension[]|undefined;
  /**
   * Default constructor for BackboneElement - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IBackboneElement> = {}) {
    super(source);
    if (source["modifierExtension"]) { this.modifierExtension = source.modifierExtension.map((x:Partial<fhir.IExtension>) => new fhir.Extension(x)); }
  }
  /**
   * Check if the current BackboneElement contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a BackboneElement from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IBackboneElement):BackboneElement {
    var dest:BackboneElement = new BackboneElement(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `BackboneElement is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
